import { SvgIcon, SvgIconProps } from "@mui/material";

export const TagsDualIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.29 6.29L5.08 13.5C4.308 14.272 4.308 15.524 5.08 16.296L9.204 20.42C9.976 21.192 11.228 21.192 12 20.42L19.21 13.21C19.395 13.025 19.5 12.773 19.5 12.511V6.989C19.5 6.443 19.057 6 18.511 6H12.988C12.726 6 12.475 6.104 12.29 6.29V6.29Z"
        fill="#8791F8"
        stroke="#5563F5"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.8342 10.1448C14.6909 10.2881 14.6909 10.5205 14.8342 10.6638C14.9776 10.8071 15.2099 10.8071 15.3533 10.6638C15.4966 10.5205 15.4966 10.2881 15.3533 10.1448C15.2099 10.0015 14.9776 10.0015 14.8342 10.1448"
        stroke="#5563F5"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.5 10L11.006 3.577C11.381 3.207 11.885 3 12.411 3H16.5"
        stroke="#5563F5"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);
